import type { Theme } from 'baseui';
import type { StyleObject } from 'styletron-react';
export const getNameStyle = (theme: Theme, secondary = false): StyleObject => ({
  ...theme.typography.LabelXSmall,
  color: secondary ? theme.colors.contentSecondary : theme.colors.contentPrimary,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  minWidth: 0
});
export const getChevronSlotStyle = (theme: Theme): StyleObject => ({
  flexShrink: 0,
  width: theme.sizing.scale600,
  height: theme.sizing.scale600
});